import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchContactFailure,
  fetchContactSuccess,
} from "../slices/features/contacts";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchContactSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchContacts,
      baseUrl,
      id,
      meta
    );

    yield put(fetchContactSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;
    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchContactFailure({ statusCode, statusText }));
  }
}

export function* watchfetchContacts() {
  yield takeLatest(RequestTypes.GET_CONTACT_REQUEST, fetchContactSaga);
}
